import { RootUspItem } from '@honeycomb/data';
import { mapCMSTextColorToThemeColor } from '@honeycomb/ui';
import { StylerProps, SvgIconBaseProps, Styler, Image, TextColorOption, TypographyHero } from '@honeycomb/ui-core';
import dynamic from 'next/dynamic';

export interface USPItemProps extends StylerProps {
    item: RootUspItem;
    index: number;
    onItemClick: (contentId: string, title: string) => void;

    /**
     * Set to `true` if the background that the icon will be displayed on is dark.
     */
    isBackgroundDark?: boolean;

    textColor?: TextColorOption;
}

const LOGO_FOLDER = './TrustpilotLogo';

export function TrBrandUSPItem(props: USPItemProps): React.JSX.Element {
    const { item, index, onItemClick, isBackgroundDark, ...other } = props;
    const { trustPilot, image, title, contentId, linkUrl, textColor: textColorProp } = item;

    const logoPath = isBackgroundDark ? `${LOGO_FOLDER}/dark` : LOGO_FOLDER;

    const textColor = textColorProp ? mapCMSTextColorToThemeColor(textColorProp) : undefined;

    const Logo = dynamic<SvgIconBaseProps>(() =>
        import(`${logoPath}/TrustpilotLogo`).then((module) => module.TrustpilotLogo)
    ) as React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<SvgIconBaseProps>>>;

    // Trustpilot
    if (trustPilot) {
        return (
            <Styler
                key={contentId}
                button={true}
                href={linkUrl ?? ''}
                target="_new"
                data-id="usp-trustpilot"
                display="inline-flex"
                alignItems="center"
                gap={2}
                flexWrap="nowrap"
                {...other}
            >
                <Image data-id={`usp-image-${index}`} src={image} width={128} height={24} />
                <Logo h={18} fill="primary.base" />
            </Styler>
        );
    }

    return (
        <Styler
            key={contentId}
            button={true}
            onClick={() => onItemClick(contentId, title)}
            data-id="usp-non-trustpilot"
            {...other}
        >
            <TypographyHero component="h3" color={textColor || 'common.white'} size="s" data-id={`usp-title-${index}`}>
                {title}
            </TypographyHero>
        </Styler>
    );
}
